/* src/app/modules/admin/admin-tabs.component.scss */
/*# sourceMappingURL=admin-tabs.component.css.map */
